import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import { ReactComponent as CloudIcon } from "assets/icons/fieldPage/ndvi-cloud.svg";
import SmallText from "../Typography/SmallText";
import NormalText from "../Typography/NormalText";

const ContainerStyled = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  "& .coverage": {
    color: theme.color.white100,
    textShadow: "2px 2px 2px black",
  },
}));

const CloudCoverage = ({ cloudCoverage, shouldDisplayIcon }) => {
  const { t } = useTranslation();

  const cloudCoverageFloor =
    typeof cloudCoverage !== "undefined"
      ? Math.floor(cloudCoverage)
      : undefined;

  return (
    <ContainerStyled>
      {shouldDisplayIcon ? (
        <CloudIcon width="20px" />
      ) : (
        <SmallText className="coverage">
          {t("Agro.Indices.CloudCoverage", { cloud: undefined })}
        </SmallText>
      )}
      <NormalText className="coverage">{cloudCoverageFloor + "%"}</NormalText>
    </ContainerStyled>
  );
};

export default CloudCoverage;
